import { useStore } from "vuex";
import { usePage } from "@inertiajs/vue3";
import { computed, onMounted, onUnmounted, ref } from "vue";
import PerfectScrollbar from "perfect-scrollbar";

export default (props) => {

    const store = useStore();
    const scrollRef = ref();
    const wrpRef = ref();
    const innerRef = ref();
    const ps = ref();
    const showMore = ref(true);
    const showMoreBtn = ref(false);
    const psHeight = ref(520);
    const innerHeight = ref(520);

    const childrenWithProducts = (category) => {
        return (category.children || []).filter(ch => ch.has_products);
    }

    const banners = computed(() => store.state.layout.menuBanners || [])
    const catalogBanner = computed(() => banners.value.find(b => b.category_id === props.category.id))
    const childrenItems = computed(() => childrenWithProducts(props.category))


    const scrollEl = (el, to) => {
        let s = el.scrollTop;
        const scrollDistance = 5; // pixel
        const scrollSpeed = 5; // 1000 = 1 seconds

        const scrollAnimate = setInterval(function () {
            if (to > 0) {
                if (s < to) {
                    s += scrollDistance;
                    el.scrollTop = s;
                } else {
                    clearInterval(scrollAnimate);
                }
            } else {
                if (s > 0) {
                    s -= scrollDistance;
                    el.scrollTop = s;
                } else {
                    clearInterval(scrollAnimate);
                }
            }

        }, scrollSpeed);
    }

    const onScroll = (evt) => {
        if (ps.value && ps.value.reach.y === 'end') {
            showMore.value = false;
        } else {
            showMore.value = true;
        }
    }

    const more = () => {
        let to = 0;
        if (showMore.value) {
            to = scrollRef.value.scrollTop + 200;
        }
        scrollEl(scrollRef.value, to)
    }

    const update = () => {
        psHeight.value = (wrpRef.value.clientHeight || 520) - 95 - 75;
        innerHeight.value = innerRef.value.clientHeight;
        ps.value.update();
        if (innerHeight.value > psHeight.value) {
            showMoreBtn.value = true;
        } else {
            showMoreBtn.value = false;
        }
        onScroll();
    }

    onMounted(() => {
        ps.value = new PerfectScrollbar(scrollRef.value, {
            swipeEasing: true,
            suppressScrollX: true,
            wheelPropagation: false,
        })
        scrollRef.value.addEventListener('ps-scroll-y', onScroll, { passive: true });
        setTimeout(() => {
            update();
        }, 100);
    })

    onUnmounted(() => {
        if (scrollRef.value) {
            scrollRef.value.removeEventListener('ps-scroll-y', onScroll);
        }

    })

    return {
        scrollRef,
        wrpRef,
        innerRef,
        showMore,
        showMoreBtn,
        psHeight,
        innerHeight,
        banners,
        catalogBanner,
        childrenItems,
        more,
        update,
        scrollEl,
        childrenWithProducts,
    }
}
